import { Component, OnInit } from '@angular/core';
import {Auth} from 'aws-amplify';
import { Router } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
  name: string;
  email:string;
  password:string;
  //phoneNumber:string;
  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  register(){
    try {
      const user = Auth.signUp({
        username: this.email,
        //name: this.name,
        password: this.password,
        //phoneNumber:this.phoneNumber,
        attributes: {
          email: this.email,
          name: this.name,
        }
      });
      console.log({ user });
      alert('User signup completed , please check verify your email.');
      this.router.navigate(['login']);
    } catch (error) {
      console.log('error signing up:', error);
    }
  }
}